// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type MarketId = ID<"market">;
export const marketIdFormat = idFormat<MarketId>({ prefix: "mkt_" });

export type MarketCountryId = ID<"marketCountry">;
export const marketCountryIdFormat = idFormat<MarketCountryId>({
  prefix: "mktc_",
});

export type MarketSyncId = ID<"marketSync">;
export const marketSyncIdFormat = idFormat<MarketSyncId>({ prefix: "mksy_" });

export type VariantQuoteId = ID<"variantQuote">;
export const variantQuoteIdFormat = idFormat<VariantQuoteId>({ prefix: "vq_" });

export type HsRateStateId = ID<"hsRateState">;
export const hsRateStateIdFormat = idFormat<HsRateStateId>({ prefix: "hrs_" });

export type CountryId = ID<"country">;
export const countryIdFormat = idFormat<CountryId>({ prefix: "ctry_" });

export type ShopifyMarketId = ID<"shopifyMarket">;
export const shopifyMarketIdFormat = idFormat<ShopifyMarketId>({
  prefix: "smkt_",
});

export type ShopifyMarketCountryId = ID<"shopifyMarketCountry">;
export const shopifyMarketCountryIdFormat = idFormat<ShopifyMarketCountryId>({
  prefix: "smc_",
});

export type ProductCountryId = ID<"productCountry">;
export const productCountryIdFormat = idFormat<ProductCountryId>({
  prefix: "pctry_",
});

export type ShopifyListingCountryId = ID<"shopifyListingCountry">;
export const shopifyListingCountryIdFormat = idFormat<ShopifyListingCountryId>({
  prefix: "slc_",
});

export type RestrictionMeasureId = ID<"restrictionMeasure">;
export const restrictionMeasureIdFormat = idFormat<RestrictionMeasureId>({
  prefix: "rmea_",
});

export type ShopifyVariantListingCountryId = ID<"shopifyVariantListingCountry">;
export const shopifyVariantListingCountryIdFormat =
  idFormat<ShopifyVariantListingCountryId>({ prefix: "svlc_" });

export type ProductPublishOverrideId = ID<"productPublishOverride">;
export const productPublishOverrideIdFormat =
  idFormat<ProductPublishOverrideId>({ prefix: "ppo_" });
